module.exports = __webpack_public_path__ + "media/memory-bank/level2-avatar-d498d881.png";